import { render, staticRenderFns } from "./AlipayFlowSpace.vue?vue&type=template&id=590e01f0&scoped=true"
import script from "./AlipayFlowSpace.vue?vue&type=script&lang=js"
export * from "./AlipayFlowSpace.vue?vue&type=script&lang=js"
import style0 from "./AlipayFlowSpace.vue?vue&type=style&index=0&id=590e01f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e01f0",
  null
  
)

export default component.exports